import React, { useEffect, useState } from "react";
import { getErrorMessage } from "../utils/Errors";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Space from "../ui/Space";
import Card from "../ui/Card";
import Menu from "../ui/Menu";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import Popup from "../ui/Popup";

export default function Bisacs(props) {

    const { value = "", callback = () => { }, route = "", modal = false } = props;
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedTitle, setSelectedTitle] = useState({});
    const [left, setLeft] = useState(true);
    const [label, setLabel] = useState({});

    const fetchAuthor = () => {
        pubCall("bisac.getAll", {}, (_s, _r) => {
            if (_s) {
                if (_r.length > 0) {
                    if (value) {
                        let _f = _r.findIndex((item) => item.code === value.slice(0, 3))
                        if (_f > -1) {
                            setSelected(_r[_f])
                            let _f2 = _r[_f].bisacs.findIndex((item) => item.bisac === value);
                            if (_r[_f].bisacs.length > 0) {
                                if (_f2 > -1) {
                                    setSelectedTitle(_r[_f].bisacs[_f2]);
                                    setLabel(_r[_f].bisacs[_f2])
                                } else {
                                    setSelectedTitle(_r[_f].bisacs[0])
                                }
                            }
                        } else {
                            setSelected(_r[0])
                        }
                    } else {
                        setSelected(_r[0]);
                    }
                    setData(_r);
                } else {
                    setSelected({});
                    setSelectedTitle({});
                }
            } else {
                showError({error : getErrorMessage(_r.error, "stock.searchAuthor")})
            }
        })
    }
    useEffect(fetchAuthor, [])

    useEffect(() => {
        if (selected?.bisacs) {
            setSelectedTitle(selected?.bisacs[0])
        }
    }, [selected])

    const switchSides = (_left = true) => {

        if (_left) {
            window.bm_state.value = route;
        } else {
            window.bm_state.value = ROUTES.HELPERS.BISACS_RIGHT;
        }

        setLeft(_left);

    }

    const setBisac = () => {
        if (window.bm_state.value !== route) {
            callback(selectedTitle.bisac);
        } else {
            switchSides(false);
        }

    }

    useEffect(() => {
        const actions = [
            { key: KBD.ENTER, action: (e) => { setBisac() } },
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.ARROW_LEFT, action: (e) => { switchSides(true) } },
        ];
        const cleanup = listen(ROUTES.HELPERS.BISACS_RIGHT, actions, false);
        return cleanup;
    }, [selected, selectedTitle]);

    useEffect(() => {
        const actions = [
            { key: KBD.ENTER, action: (e) => { setBisac() } },
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.ARROW_RIGHT, action: (e) => { switchSides(false) } },
        ];
        const cleanup = listen(route, actions, false);
        return cleanup;
    }, [selected, selectedTitle]);


    const bisac_columns = [
        { key: "code", align: "center", title: <>Code</>, width: 60 },
        { key: "description", align: "left", title: <>Description</>, width: 289 },
    ]

    const title_columns = [
        { key: "bisac", align: "left", title: <>Bisac</>, width: 110, },
        {
            key: "description", align: "left", title: <>Description</>, width: 470
        },
    ]

    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const currentIndex = data.findIndex(item => item?.code === selected?.code);
        const nextIndex = Math.min(currentIndex + _rows, data.length - 1);
        setSelected(data[nextIndex]);
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const currentIndex = data.findIndex(item => item?.code === selected?.code);
        const prevIndex = Math.max(currentIndex - _rows, 0);
        setSelected(data[prevIndex]);
    };

    const nextTitle = (_rows = 1) => {
        if (selected?.bisacs.length === 0) { setSelectedTitle({}); return; }
        const currentIndex = selected.bisacs.findIndex(item => item?.bisac === selectedTitle?.bisac);
        const nextIndex = Math.min(currentIndex + _rows, selected.bisacs.length - 1);
        setSelectedTitle(selected.bisacs[nextIndex]);
    };

    const prevTitle = (_rows = 1) => {
        if (selected?.bisacs.length === 0) { setSelectedTitle({}); return; }
        const currentIndex = selected.bisacs.findIndex(item => item?.bisac === selectedTitle?.bisac);
        const prevIndex = Math.max(currentIndex - _rows, 0);
        setSelectedTitle(selected.bisacs[prevIndex]);
    };

    const drawMessage = () => {
        if (left) {
            return (<>Browse BISAC group ({data.length} available) Press {KBD.ARROW_RIGHT.label} to select a BISAC in this group.</>)
        } else {
            return (<>Browsing {selected?.code}.  Press {KBD.ARROW_LEFT.label} to browse BISAC groups.  Press <strong>{KBD.ENTER.label}</strong> to select.</>)
        }
    }

    const draw = () => {
        return (
            <div style={{ "padding": (modal) ? "0px" : "0px 5px", "paddingBottom": (modal) ? "0px" : "5px" }}>
                <div className="shim" />
                <Space>
                    <div style={{ "opacity": (!left) ? "0.7" : "1" }} onClick={() => switchSides(true)}>
                        <VirtualTable
                            row_key={"code"}
                            next={next}
                            prev={prev}
                            route={route}
                            current={selected}
                            data={data}
                            width={310}
                            height={388}
                            offset={0}
                            columns={bisac_columns}
                            onRowClick={(item, event, index) => { switchSides(true); setSelected(item) }}
                        />
                    </div>

                    <div style={{ "opacity": (left) ? "0.7" : "1" }} onClick={() => switchSides(false)}>
                        <VirtualTable
                            row_key={"bisac"}
                            next={nextTitle}
                            prev={prevTitle}
                            onRowClick={(item) => { switchSides(false); setSelectedTitle(item) }}
                            onRowDoubleClick={(item) => { callback(item.bisac); }}
                            route={ROUTES.HELPERS.BISACS_RIGHT}
                            current={selectedTitle}
                            data={selected?.bisacs}
                            width={600}
                            height={388}
                            offset={0}
                            columns={title_columns}
                        />
                    </div>

                </Space>
                <div className="shim" /><div className="shim" />
                <Status><InfoIcon />{drawMessage()}</Status>
            </div>
        )
    }

    const drawTitle = () => {
        if (label?.bisac) {
            return (<>BISAC - {label?.bisac} - {label.description}</>)
        } else {
            return (<>BISACs</>)
        }
    }

    if(modal){
        return <><div className="shim" />{draw()}</>; 
    }

    return (<>
        <Popup
            title={drawTitle()}
            width={"auto"}
            callback={callback}
            component={draw()}
        />
    </>)
}

